import React from 'react';
import { scrollToId } from '@/lib/scroll';

export const TOCItem: React.FC<{
  id: string;
  label: string;
  level: number;
  activeId: string;
}> = ({ id, label, level, activeId }) => {
  const isActive = activeId === id;
  const paddingLeft = level === 1 ? 'pl-0' : level === 2 ? 'pl-4' : 'pl-8';

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (typeof window === 'undefined') return;
    const didScroll = scrollToId(id);
    if (didScroll) {
      window.history.pushState(null, '', `#${id}`);
    }
  };

  return (
    <a
      href={`#${id}`}
      onClick={handleClick}
      className={`block py-1.5 text-sm transition-colors duration-200 ${paddingLeft} ${
        isActive
          ? 'text-blue-600 dark:text-blue-400 font-medium'
          : 'text-zinc-600 dark:text-zinc-400 hover:text-blue-600 dark:hover:text-blue-400'
      }`}
    >
      {label}
    </a>
  );
};
